import { render, staticRenderFns } from "./MyCalendarTasks.vue?vue&type=template&id=295166b4"
import script from "./MyCalendarTasks.vue?vue&type=script&lang=js"
export * from "./MyCalendarTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports